/* ==========================================================================
   HERAVIRES PDP — buy box behaviour
   ==========================================================================
   Drives sections/heravires-pdp-main.liquid: variant picker, gallery, bundle
   tiers, quantity stepper, countdown, size-chart modal and sticky add-to-cart.

   Every value this file needs arrives through the DOM — the JSON config island
   and data-* attributes — so the asset stays static and cacheable, and one
   copy serves any number of section instances.

   Re-entrant on purpose: init() runs on DOMContentLoaded and again on
   shopify:section:load, guarded by data-hp-ready, so the Theme Editor can
   re-render the section without double-binding or losing behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var READY_VERSION = 'bundle-v3';

  function initSection(root) {
    if (!root || root.dataset.hpReady === READY_VERSION) return;
    root.dataset.hpReady = READY_VERSION;

    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    /* ---- config ---------------------------------------------------------- */
    var config = { moneyFormat: '${{amount}}', atcLabel: 'Add to cart', soldOutLabel: 'Sold out' };
    var configIsland = q('[data-hp-config]');
    if (configIsland) {
      try { config = JSON.parse(configIsland.textContent); } catch (e) {}
    }

    var variants = [];
    var variantIsland = q('[data-hp-variants]');
    if (variantIsland) {
      try { variants = JSON.parse(variantIsland.textContent) || []; } catch (e) { variants = []; }
    }

    var form        = q('[data-hp-form]');
    var idInput     = q('[data-hp-variant-id]');
    var atcBtn      = q('[data-hp-atc]');
    var atcText     = q('[data-hp-atc-text]');
    var priceNow    = q('[data-hp-price-now]');
    var priceWas    = q('[data-hp-price-was]');
    var priceSave   = q('[data-hp-price-save]');
    var qtyInput    = q('[data-hp-qty]');
    var stickyPrice = q('[data-hp-sticky-price]');
    var stickyImg   = q('[data-hp-sticky-img]');
    var bundleItems = q('[data-hp-bundle-items]');
    var bundleStatus = q('[data-hp-bundle-status]');
    var primaryPairLabel = q('[data-hp-primary-pair-label]');
    var dynamicCheckout = q('[data-hp-dynamic-checkout]');
    var bundleSubmitting = false;

    /* ---- money ----------------------------------------------------------- */
    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var dot   = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return config.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, comma + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, comma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dot + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, dot);
    }

    /* ---- gallery --------------------------------------------------------- */
    var thumbTrack = q('[data-hp-thumbs]');
    var thumbPrev  = q('[data-hp-thumbs-prev]');
    var thumbNext  = q('[data-hp-thumbs-next]');

    function updateThumbNav() {
      if (!thumbTrack) return;
      var maxScroll = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
      if (thumbPrev) thumbPrev.disabled = thumbTrack.scrollLeft <= 1;
      if (thumbNext) thumbNext.disabled = thumbTrack.scrollLeft >= maxScroll - 1;
    }

    function keepThumbVisible(thumb) {
      if (!thumbTrack || !thumb) return;
      var trackRect = thumbTrack.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();

      if (thumbRect.left < trackRect.left) {
        thumbTrack.scrollBy({ left: thumbRect.left - trackRect.left, behavior: 'smooth' });
      } else if (thumbRect.right > trackRect.right) {
        thumbTrack.scrollBy({ left: thumbRect.right - trackRect.right, behavior: 'smooth' });
      }
    }

    function activateSlide(index) {
      qa('[data-hp-slide]').forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.hpSlide === String(index));
      });
      qa('[data-hp-thumb]').forEach(function (btn) {
        var isActive = btn.dataset.hpThumb === String(index);
        btn.setAttribute('aria-current', isActive ? 'true' : 'false');
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) keepThumbVisible(btn);
      });
    }

    /* Delegate thumbnail clicks from the section root. This remains reliable
       when Shopify re-renders or replaces the thumbnail buttons in the Theme
       Editor, and also upgrades roots initialized by an older asset version. */
    root.addEventListener('click', function (event) {
      var target = event.target;
      var btn = target && target.closest ? target.closest('[data-hp-thumb]') : null;
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      activateSlide(btn.dataset.hpThumb);
    });

    function scrollThumbs(direction) {
      if (!thumbTrack) return;
      var firstThumb = q('[data-hp-thumb]');
      var styles = window.getComputedStyle(thumbTrack);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = firstThumb ? (firstThumb.getBoundingClientRect().width + gap) * 4 : thumbTrack.clientWidth * .8;
      thumbTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', updateThumbNav, { passive: true });
      if (thumbPrev) thumbPrev.addEventListener('click', function () { scrollThumbs(-1); });
      if (thumbNext) thumbNext.addEventListener('click', function () { scrollThumbs(1); });
      window.requestAnimationFrame(updateThumbNav);
      window.addEventListener('resize', updateThumbNav);
    }

    function showSlideByMediaId(mediaId) {
      if (!mediaId) return;
      var target = q('[data-hp-media-id="' + mediaId + '"]');
      if (target) activateSlide(target.dataset.hpSlide);
    }

    /* ---- variants -------------------------------------------------------- */
    function selectedOptions() {
      var values = [];
      qa('[data-hp-option-input]').forEach(function (input) {
        if (input.checked) values[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* Cross out option values that cannot reach an available variant */
    function refreshAvailability(values) {
      qa('[data-hp-option-input]').forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var probe = values.slice();
        probe[idx] = input.value;

        input.disabled = !variants.some(function (v) {
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== undefined && v.options[j] !== probe[j]) return false;
          }
          return v.available;
        });
      });
    }

    function selectedBundleOptions(itemIndex) {
      var values = [];
      qa('[data-hp-bundle-option-input][data-bundle-item="' + itemIndex + '"]').forEach(function (input) {
        if (input.checked) values[parseInt(input.dataset.optionIndex, 10)] = input.value;
      });
      return values;
    }

    function refreshBundleAvailability(itemIndex, values) {
      qa('[data-hp-bundle-option-input][data-bundle-item="' + itemIndex + '"]').forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var probe = values.slice();
        probe[idx] = input.value;

        input.disabled = !variants.some(function (variant) {
          for (var j = 0; j < probe.length; j++) {
            if (probe[j] !== undefined && variant.options[j] !== probe[j]) return false;
          }
          return variant.available;
        });
      });
    }

    function selectedTierQuantity() {
      var selectedTier = q('[data-hp-tier]:checked');
      if (selectedTier) return Math.max(1, parseInt(selectedTier.value, 10) || 1);
      return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    }

    function setBundleStatus(message) {
      if (!bundleStatus) return;
      bundleStatus.textContent = message || '';
      bundleStatus.hidden = !message;
    }

    function resolveBundleVariants(quantity) {
      var result = { variants: [], invalidItem: 0 };
      var primaryVariant = findVariant(selectedOptions());

      if (!primaryVariant || !primaryVariant.available) {
        result.invalidItem = 1;
        return result;
      }
      result.variants.push(primaryVariant);

      for (var itemIndex = 2; itemIndex <= quantity; itemIndex++) {
        var bundleVariant = findVariant(selectedBundleOptions(itemIndex));
        if (!bundleVariant || !bundleVariant.available) {
          result.invalidItem = itemIndex;
          return result;
        }
        result.variants.push(bundleVariant);
      }

      return result;
    }

    function updateSelectedTierPrice(selectedVariants) {
      var selectedTier = q('[data-hp-tier]:checked');
      if (!selectedTier || !selectedVariants.length) return;

      var tierCard = selectedTier.closest('.heravires-pdp-tier');
      var totalEl = tierCard && tierCard.querySelector('[data-hp-tier-total]');
      var fullEl = tierCard && tierCard.querySelector('[data-hp-tier-full]');
      if (!totalEl) return;

      var full = selectedVariants.reduce(function (sum, variant) { return sum + variant.price; }, 0);
      var discount = parseFloat(totalEl.dataset.discount) || 0;
      totalEl.textContent = formatMoney(Math.round(full - (full * discount / 100)));
      if (fullEl) fullEl.textContent = formatMoney(full);
    }

    function syncBundleItems() {
      var quantity = selectedTierQuantity();
      var hasPerPairPickers = !!bundleItems && quantity > 1;
      if (qtyInput) qtyInput.value = quantity;

      if (bundleItems) bundleItems.hidden = !hasPerPairPickers;
      if (primaryPairLabel) primaryPairLabel.hidden = !hasPerPairPickers;
      if (dynamicCheckout) dynamicCheckout.hidden = hasPerPairPickers;

      qa('[data-hp-bundle-item]').forEach(function (item) {
        var itemIndex = parseInt(item.dataset.hpBundleItem, 10);
        var isVisible = hasPerPairPickers && itemIndex <= quantity;
        item.hidden = !isVisible;

        var itemInputs = Array.prototype.slice.call(item.querySelectorAll('[data-hp-bundle-option-input]'));
        if (!isVisible) {
          itemInputs.forEach(function (input) { input.disabled = true; });
          return;
        }

        var values = selectedBundleOptions(itemIndex);
        refreshBundleAvailability(itemIndex, values);
        qa('[data-hp-bundle-option-value][data-bundle-item="' + itemIndex + '"]').forEach(function (label) {
          var optionIndex = parseInt(label.dataset.optionIndex, 10);
          if (values[optionIndex]) label.textContent = values[optionIndex];
        });
      });

      var resolution = resolveBundleVariants(quantity);
      var allAvailable = !resolution.invalidItem && resolution.variants.length === quantity;
      if (atcBtn) atcBtn.disabled = !allAvailable;
      if (atcText) atcText.textContent = allAvailable ? config.atcLabel : config.soldOutLabel;

      if (allAvailable) {
        setBundleStatus('');
        updateSelectedTierPrice(resolution.variants);
      } else {
        setBundleStatus('The selected options for Pair ' + resolution.invalidItem + ' are unavailable.');
      }

      return resolution;
    }

    function updateTierPrices(unitPrice) {
      qa('[data-hp-tier-total]').forEach(function (el) {
        var qty = parseInt(el.dataset.qty, 10) || 1;
        var discount = parseFloat(el.dataset.discount) || 0;
        var full = unitPrice * qty;
        el.textContent = formatMoney(Math.round(full - (full * discount / 100)));

        var fullEl = el.parentNode.querySelector('[data-hp-tier-full]');
        if (fullEl) fullEl.textContent = formatMoney(full);
      });
    }

    function updateVariant() {
      var values = selectedOptions();
      var variant = findVariant(values);

      refreshAvailability(values);

      qa('[data-hp-option-value]').forEach(function (el) {
        var idx = parseInt(el.dataset.hpOptionValue, 10);
        if (values[idx]) el.textContent = values[idx];
      });

      if (!variant) {
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = config.soldOutLabel;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (atcBtn) atcBtn.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? config.atcLabel : config.soldOutLabel;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) {
        priceWas.hidden = !onSale;
        if (onSale) priceWas.textContent = formatMoney(variant.compare_at_price);
      }
      if (priceSave) {
        priceSave.hidden = !onSale;
        if (onSale) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          priceSave.textContent = 'Save ' + pct + '%';
        }
      }

      if (stickyPrice) {
        stickyPrice.innerHTML = (onSale ? '<s>' + formatMoney(variant.compare_at_price) + '</s> ' : '') + formatMoney(variant.price);
      }
      if (stickyImg && variant.featured_image) {
        stickyImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1');
      }

      updateTierPrices(variant.price);
      showSlideByMediaId(variant.featured_image && variant.featured_image.id);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      syncBundleItems();
    }

    qa('[data-hp-option-input]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    qa('[data-hp-bundle-option-input]').forEach(function (input) {
      input.addEventListener('change', syncBundleItems);
    });

    /* ---- quantity stepper ------------------------------------------------ */
    qa('[data-hp-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.hpQtyStep, 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    /* ---- bundle tiers ---------------------------------------------------- */
    qa('[data-hp-tier]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) syncBundleItems();
      });
      if (input.checked && qtyInput) qtyInput.value = input.value;
    });

    function buildCartItems(selectedVariants) {
      var grouped = {};
      selectedVariants.forEach(function (variant) {
        var id = String(variant.id);
        if (!grouped[id]) grouped[id] = { id: variant.id, quantity: 0 };
        grouped[id].quantity += 1;
      });
      return Object.keys(grouped).map(function (id) { return grouped[id]; });
    }

    /* A normal Shopify product form can submit one variant with a quantity.
       Mixed bundles need the Ajax Cart API so Pair 1, Pair 2 and Pair 3 can
       each carry a different variant ID. Buy 1 keeps the original form flow. */
    if (form) {
      form.addEventListener('submit', function (event) {
        var quantity = selectedTierQuantity();
        if (quantity <= 1 || !bundleItems) return;

        event.preventDefault();
        if (bundleSubmitting) return;

        var resolution = syncBundleItems();
        if (resolution.invalidItem || resolution.variants.length !== quantity) return;

        bundleSubmitting = true;
        setBundleStatus('');
        if (atcBtn) atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Adding...';

        var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        if (routesRoot.charAt(routesRoot.length - 1) !== '/') routesRoot += '/';

        fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: buildCartItems(resolution.variants) })
        })
          .then(function (response) {
            return response.json().catch(function () { return {}; }).then(function (payload) {
              if (!response.ok) throw new Error(payload.description || 'The bundle could not be added to cart.');
              return payload;
            });
          })
          .then(function () {
            window.location.assign(routesRoot + 'cart');
          })
          .catch(function (error) {
            bundleSubmitting = false;
            if (atcBtn) atcBtn.disabled = false;
            if (atcText) atcText.textContent = config.atcLabel;
            setBundleStatus(error.message || 'The bundle could not be added to cart. Please try again.');
          });
      });
    }

    /* ---- countdown ------------------------------------------------------- */
    var countdown = q('[data-hp-countdown]');
    if (countdown) {
      var minutes = parseInt(countdown.dataset.minutes, 10) || 60;
      var storageKey = countdown.dataset.key;
      var deadline;

      try {
        var stored = window.localStorage.getItem(storageKey);
        deadline = stored ? parseInt(stored, 10) : NaN;
      } catch (e) { deadline = NaN; }

      if (!deadline || isNaN(deadline) || deadline < Date.now()) {
        deadline = Date.now() + minutes * 60 * 1000;
        try { window.localStorage.setItem(storageKey, String(deadline)); } catch (e) {}
      }

      var hh = countdown.querySelector('[data-hp-hh]');
      var mm = countdown.querySelector('[data-hp-mm]');
      var ss = countdown.querySelector('[data-hp-ss]');
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var timer;

      var tick = function () {
        var left = Math.max(0, deadline - Date.now());
        var total = Math.floor(left / 1000);
        if (hh) hh.textContent = pad(Math.floor(total / 3600));
        if (mm) mm.textContent = pad(Math.floor(total % 3600 / 60));
        if (ss) ss.textContent = pad(total % 60);
        if (left === 0 && timer) clearInterval(timer);
      };

      tick();
      timer = setInterval(tick, 1000);
    }

    /* ---- size chart modal ------------------------------------------------ */
    var modal = q('[data-hp-modal]');
    if (modal) {
      var openModal = function () { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
      var closeModal = function () { modal.classList.remove('is-open'); document.body.style.overflow = ''; };

      qa('[data-hp-open-modal]').forEach(function (b) { b.addEventListener('click', openModal); });
      qa('[data-hp-close-modal]').forEach(function (b) { b.addEventListener('click', closeModal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
      });
    }

    /* ---- sticky bar ------------------------------------------------------ */
    var sticky = q('[data-hp-sticky]');
    if (sticky && atcBtn) {
      var stickyAtc = q('[data-hp-sticky-atc]');
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          if (form && typeof form.requestSubmit === 'function') form.requestSubmit(atcBtn);
          else atcBtn.click();
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }).observe(atcBtn);
      }
    }

    /* ---- initial sync ---------------------------------------------------- */
    if (variants.length) updateVariant();
  }

  /* Any section on the page that asks for this behaviour. Scoped per instance,
     so a product page could carry more than one without them interfering. */
  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-heravires-pdp-main]');
    Array.prototype.forEach.call(nodes, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme Editor re-renders the section in place; bind the fresh markup. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  /* Close the size chart when the editor unloads a section, so a stale
     overflow:hidden cannot leave the page unscrollable. */
  document.addEventListener('shopify:section:unload', function () {
    document.body.style.overflow = '';
  });
})();
